// extracted by mini-css-extract-plugin
export var accent = "_2o-4";
export var add = "_2o-j";
export var addIcon = "_2o-k";
export var deleteIcon = "_2o-i";
export var disabled = "_2o-9";
export var ellipsis = "_2o-f";
export var error = "_2o-3";
export var form = "_2o-5";
export var hideFocus = "_2o-2";
export var icon = "_2o-7";
export var input = "_2o-e";
export var listItem = "_2o-h";
export var mediumHeight = "_2o-b";
export var noBorder = "_2o-8";
export var noRadius = "_2o-1";
export var shortHeight = "_2o-a";
export var tallHeight = "_2o-c";
export var textInput = "_2o-0";
export var vertical = "_2o-g";
export var veryTallHeight = "_2o-d";
export var widget = "_2o-6";